<template>
    <!-- IE 2026 10 18 / ODOO-347310: изображение записи (товар из Odoo) по ссылке на файл в НАШЕМ S3 — через /api/object_image/ -->
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <div class="attr-image-url" v-wjTooltip="attr.tooltip">
            <label class="label-attr" v-if="attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</label>
            <div class="attr-image-url-wrap" :id="attr.html_id" :class="attr.cssClass" :style="attr.cssStyle">
                <img v-if="url" :src="url" class="attr-image-url-img" alt="" @click="open" :title="t('Open the image in a new tab')" />
                <div v-else class="attr-image-url-empty"><i class="pi pi-image" /><span v-if="loading" class="pi pi-spin pi-spinner"></span></div>
            </div>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { loadImage, openImage } from '@/utils/sourceImage'

export default {
    props: ['widget_id', 'attr_id'],
    data: () => ({ WIDGET: {}, src: '', url: '', loading: false }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    created() {
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    methods: {
        content_Changed() {
            this.store.widget_attr_set(this)
            const v = this.store.attr_get(this.WIDGET, this.attr)
            const src = typeof v === 'string' ? v.trim() : (v?.value || v?.src || '')
            if (src === this.src) return
            this.src = src
            this.url = ''
            if (!src) return
            this.loading = true
            loadImage(this.store, src, this.attr?.imageSize || 512).then(u => {
                if (this.src !== src) return
                this.url = u
                this.loading = false
            })
        },
        open() { if (this.src) openImage(this.store, this.src) },
    },
}
</script>

<style scoped>
.attr-image-url { display: flex; flex-direction: column; gap: 4px; }
.attr-image-url-wrap { display: flex; align-items: center; justify-content: center; width: 16rem; max-width: 100%; height: 16rem;
    border: 1px solid var(--surface-border, #e2e8f0); border-radius: 8px; background: var(--surface-ground, #f8fafc); overflow: hidden; }
.attr-image-url-img { max-width: 100%; max-height: 100%; object-fit: contain; cursor: zoom-in; }
.attr-image-url-empty { color: var(--text-color-secondary, #94a3b8); font-size: 2rem; display: flex; gap: 8px; align-items: center; }
</style>
